<template>
    <a 
        :class="[
            needClass === false? '': 'cp btn',
            themes? 'is-'+ themes: 'is-major',
            icon? 'icon-font '+ icon: '',
            text === '' && icon? 'icon-font-only': '',
            extendClass? extendClass: '',
        ]"
        @click.prevent.stop="click"
        @mouseenter.prevent.stop="mouseenter"
        :disabled="disabled"
    >
        <!-- :title="title || text || $t('site.noun.settings')" -->
        <span>{{ text }}</span>
        <slot></slot>
    </a>
</template>

<script>
    import { mapMutations } from 'vuex'

    export default {
        props: {
            themes: {
                type: String,
                require: false,
                default: ''
            },
            title: {
                type: String,
                require: false,
                default: ''
            },
            text: {
                type: String,
                require: false,
                default: ''
            },
            func: {
                require: false,
            },
            icon: {
                type: String,
                require: false,
                default: ''
            },
            extendClass: {
                type: String,
                require: false,
                default: ''
            },
            needClass: {
                type: Boolean,
                require: false,
                default: true
            },
            disabled: {
                type: Boolean,
                require: false,
                default: false
            },
            href: {
                type: String,
                require: false,
                default: ''
            },
            target: {
                type: String,
                require: false,
                default: ''
            },
            width: { //指定按鈕長度(px)
                type: String,
                require: false
            },
        },
        methods: {
            ...mapMutations([
                'pushToolTip',
            ]),
            click: function(evt){
                let _func = this.func,
                    _href = this.href;

                if( _href ) {
                    window.open(_href, this.target);
                }else if( !_func ) {
                    this.$emit('click', evt);
                }else if( typeof _func === 'string' ) {
                    this.$emit('sendEvent', _func, evt);
                }else if( typeof _func === 'function' ) {
                    _func(evt);
                }else if( _func === 'null' ) {
                    _func(evt);
                }else {
                    console.log(_func, evt);
                }
            },
            mouseenter: function(evt){
                let _title = this.title,
                    _text = this.text;

                if( _title || _text ){
                
                    this.pushToolTip({
                        type: 'toolTip',
                        event: evt,
                        content: {
                            html: _title || _text,
                        },
                        pointerEvents: 'none'
                    });
                }
            }
        }
    }
</script>

<style scoped lang="scss">

    a { //按鈕組件
        $default: 'normal'; //預設的顏色組

        $color: map-get($colors, $default);
        $bg: map-get($color, 'background');
        $bd: map-get($color, 'border');
        $tx: map-get($color, 'text');
        
        user-select: none;
        display: inline-block;
        box-sizing: border-box;
        text-align: center;
        cursor: pointer;
        text-decoration: none !important;
        transition: $transition;
        border: $border;
        border-radius: $border-radius;
        vertical-align: middle;
        padding: $btnInput_pd $interval-m;
        margin: 1px;
        line-height: $btnInput_lh;
        height: $btnInput_lh + $btnInput_pd * 2;
        font-size: .9em;
        white-space: nowrap;
        border-color: $bd;
        background-color: $bg;
        color: $tx !important;

        &[disabled] {
            opacity: $opacity-h;
        }

        @include media('mobile') {
            padding: $btnInput_pd $interval-xs;
        }

        &:hover {
            background-color: rgba-set($bg, $opacity-h);
        }

        &.is-block {
            display: block;
            width: 100%;
            text-align: center;
        }

        &.is-large {
            height: auto;
            line-height: $line-height-m;
            font-size: $font-size-xl;
        }

        

        &.icon-font {

            &::before {
                vertical-align: middle;
            }

            &::after {
                content: '';
                display: inline-block;
                width: .1rem;
            }

            &.icon-font-only {
                padding-left: $interval-m;
                padding-right: $interval-m;

                &::before {
                    margin-right: 0;
                    font-size: $font-size-l;
                }

                &::after {
                    display: none;
                }
            }

            span {
                margin-left: $interval-xs;
            }
        }

        @each $key, $map in $colors {
            $bg: map-get($map, 'background');
            $bd: map-get($map, 'border');
            $tx: map-get($map, 'text');

            &.is-#{$key} {
                background-color: $bg;
                border-color: $bd;
                color: $tx !important;

                &:hover {
                    background-color: rgba-set($bg, $opacity-h);
                }

                &.is-hover { //將按鈕的背景色與文字顏色調換
                    background-color: transparent; //取背景預設值
                    color: $bd !important; 

                    &:hover {
                        background-color: $bg;
                        color: $white !important;
                    }
                }

                &.is-icon { //取消背景色與框線
                    background-color: transparent; //取背景預設值
                    color: $tx !important;
                    border: 0;

                    &:hover {
                        color: rgb-set($tx, $opacity-h)!important;
                    }
                }

                &.is-light{
                    background-color: $tx; //取背景預設值
                    color: $bd !important; 
                    border: $border; 
                    text-align: left;
                    margin: 0;

                    &:hover{
                        background-color: $light;
                        color: $bd;
                    }

                    span{
                        display: inline-block;
                        width: 80%;
                        margin-left: $interval-m;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }
            }
        }

        span {
            display: inline-block;
            vertical-align: middle;
            line-height: 1;
        }
    }
</style>
